import { alpha, styled } from '@mui/material/styles';
import ListItem from '@mui/material/ListItem';
import { ListItemText } from '@mui/material';
import { ReactNode, useState } from 'react';
import { AnimatedCollapse } from '../components/animatedCollapse/AnimatedCollapse';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
interface Props {
  title: string;
  subtitle?: string;
  children: ReactNode;
  nestedLevel?: number;
  icon?: ReactNode;
}

const Root = styled(ListItem)<any>(({ theme, itempadding, ...props }) => ({
  minminHeight: 44,
  width: '100%',
  borderRadius: '6px',
  margin: '14px 0 0 0',
  paddingRight: 16,
  paddingLeft: props.itempadding > 80 ? 80 : props.itempadding,
  paddingTop: 10,
  paddingBottom: 10,
  color: '#B9BDF8', // Color de texto del menú según diseño
  fontWeight: 600,
  letterSpacing: '0.025em',
}));

const NavGroup = (props: Props) => {
  const [collapse, setCollapse] = useState(false);
  const { title, subtitle, children, nestedLevel = 0 } = props;
  const itempadding = nestedLevel > 0 ? 38 + nestedLevel * 16 : 16;

  return (
    <>
      <Root
        onClick={() => setCollapse(!collapse)}
        component="li"
        style={{ cursor: 'pointer' }}
        itempadding={itempadding}
        className="fuse-list-subheader flex items-center justify-between pb-10 cursor-default "
        role="button"
      >
        <ListItemText
          className="fuse-list-subheader-text"
          sx={{
            margin: 0,
            '& > .MuiListItemText-primary': {
              fontSize: 12,
              color: 'secondary.light',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: '.05em',
              lineHeight: '20px',
            },

            '& > .MuiListItemText-secondary': {
              fontSize: 11,
              color: 'text.disabled',
              letterSpacing: '.06px',
              fontWeight: 500,
              lineHeight: '1.5',
            },
          }}
          primary={title}
          secondary={subtitle}
        />
        {collapse && <ExpandLessIcon />}
        {!collapse && <ExpandMoreIcon />}
      </Root>
      <AnimatedCollapse collapse={collapse}>{children}</AnimatedCollapse>
    </>
  );
};

export default NavGroup;
